//@flow
import * as fontConfigs from "./font-configs";
export { fontConfigs };